module.exports = __webpack_public_path__ + "img/1_1-basket-1.ab169d72.png";